function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import * as DOMPurify from "dompurify";
import * as React from "react";
import { TOP_NAV_HEIGHT } from "../NavigationUtils/NavigationUtils";
import { throttle } from "../throttle/throttle";
/**
 * These tags are always forbidden in setInnerHtmlSanitized.
 * See http://go/dompurify-security
 * The default allowed tags are the set of tags defined at
 * https://github.com/cure53/DOMPurify/blob/main/src/tags.js
 * excluding FORBIDDEN_TAGS.
 */ var FORBIDDEN_TAGS = [
    "style"
];
var KAGGLE_DOMAIN_RE = /^(www\.|staging\.|admin\.)?kaggle\.com$/i;
var EXTERNAL_DOMAIN_REL_VALUES = [
    "noreferrer",
    "nofollow", 
];
var ALLOWED_IMG_PREFIXES = [
    "i.postimg.cc/",
    "i.imgur.com/",
    "pbs.twimg.com/",
    "i.ibb.co/",
    "raw.githubusercontent.com/",
    "user-images.githubusercontent.com/",
    "storage.googleapis.com/",
    "www.kaggleusercontent.com/",
    "www.googleapis.com/download/storage/v1", 
];
var ALLOWED_IFRAME_HOSTNAMES = [
    "www.youtube.com",
    "youtu.be", 
];
var EXTERNAL_MEDIA_CLASS_NAME = "external-media-link";
var DEFAULT_SANITIZE_CONFIG = {
    allowUnsanitized: false,
    allowExternalImages: true,
    allowAnchorTarget: false,
    allowIframe: false,
    unsafe_allowStyle: false
};
// Returns "noreferrer nofollow" if the href is an external domain.
export var getRelAttrForHref = function(href) {
    if (isKaggleUrl(href)) {
        return undefined;
    }
    return EXTERNAL_DOMAIN_REL_VALUES.join(" ");
};
/**
 * Takes a function that matches URL objects and returns a
 * function that matches arbitrary stings - which may or may not
 * be valid URLs. Invalid URLs will return false.
 */ var getUrlStringMatcher = function(urlFn) {
    return function(urlStr) {
        var url;
        try {
            url = new URL(urlStr, window.location.href);
        } catch (_) {
            // Return false for unparseable URL.
            return false;
        }
        return urlFn(url);
    };
};
var isKaggleDomain = function(url) {
    return url.hostname.match(KAGGLE_DOMAIN_RE) !== null;
};
// used an optimization to prevent loading some admin components on the prod site
export var isKaggleProdDomain = function() {
    return window.location.hostname === "www.kaggle.com" || window.location.hostname === "kaggle.com";
};
/**
 * Returns true if the URL is relative or a Kaggle domain.
 */ export var isKaggleUrl = getUrlStringMatcher(isKaggleDomain);
/**
 * Returns true if the URL is relative, a Kaggle domain,
 * or one of the allowed 3rd party image domains.
 */ export var isAllowedImgDomainUrl = getUrlStringMatcher(function(url) {
    if (isKaggleDomain(url)) {
        return true;
    }
    var hostAndPath = url.hostname.toLowerCase() + url.pathname.toLocaleLowerCase();
    // Do a head match on domain and path.
    return ALLOWED_IMG_PREFIXES.some(function(prefix) {
        return hostAndPath.indexOf(prefix) === 0;
    });
});
var createExternalLink = function(src, icon) {
    // Create a new link that links to the image src.
    var link = document.createElement("a");
    link.setAttribute("href", src);
    link.setAttribute("class", EXTERNAL_MEDIA_CLASS_NAME);
    link.appendChild(icon);
    // Set the text of the link.
    var text = document.createTextNode(src);
    link.appendChild(text);
    return link;
};
/**
 * @param icon A valid material IconOption. Official type is not visible from
 *     @kaggle/core, so we use a string instead.
 */ var createIcon = function(iconOption) {
    var icon = document.createElement("i");
    icon.setAttribute("class", "rmwc-icon google-material-icons markdown-renderer-image-icon");
    var iconText = document.createTextNode(iconOption);
    icon.appendChild(iconText);
    return icon;
};
var cachedImageIcon = null;
var getImageIcon = function() {
    if (cachedImageIcon !== null) {
        return cachedImageIcon;
    }
    var icon = createIcon("image");
    cachedImageIcon = icon;
    return icon;
};
var cachedOpenInNewIcon = null;
var getOpenInNewIcon = function() {
    if (cachedOpenInNewIcon !== null) {
        return cachedOpenInNewIcon;
    }
    var icon = createIcon("open_in_new");
    cachedOpenInNewIcon = icon;
    return icon;
};
/**
 * Adds the attribute rel="noreferrer nofollow" if the anchor
 * element links to a non-Kaggle domain.
 */ export var processAnchorRel = function(elem) {
    var href = elem.getAttribute("href");
    if (href !== null && !isKaggleUrl(href)) {
        var currentRel = elem.getAttribute("rel") || "";
        // The same node can be processed multiple times, so don't duplicate values.
        var relVals = new Set(_toConsumableArray(currentRel.split(/\s+/)).concat(_toConsumableArray(EXTERNAL_DOMAIN_REL_VALUES)));
        elem.setAttribute("rel", _toConsumableArray(relVals).join(" "));
    }
};
/**
 * If iframes are disallowed or from a disallowed domain, replace them with
 * an external link to the content.
 */ var processIframe = function(elem, sanitizeConfig) {
    var src = elem.getAttribute("src");
    if (src === null) {
        var ref;
        (ref = elem.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(elem);
        return;
    }
    // If the iframe is not allowed, replace it with a link to the src.
    var hostname = new URL(src).hostname;
    if (!sanitizeConfig.allowIframe || !ALLOWED_IFRAME_HOSTNAMES.includes(hostname)) {
        var link = createExternalLink(src, getOpenInNewIcon());
        elem.replaceWith(link);
        return;
    }
    // If allowed, apply a set of default attributes to the iframe.
    elem.setAttribute("referrerpolicy", "strict-origin");
    elem.setAttribute("allow", "encryped-media");
};
/**
 * Replaces 3rd-party image elements with links.
 */ export var processImgSrc = function(elem) {
    var src = elem.getAttribute("src");
    if (src !== null && !isAllowedImgDomainUrl(src)) {
        // Create a new link that links to the image src.
        var link = createExternalLink(src, getImageIcon());
        // Replace the img element.
        elem.replaceWith(link);
    }
};
/**
 * Type-guard that narrows Element to HTMLAnchorElement
 */ var nodeIsAnchor = function(node) {
    return node.nodeType === 1 && node.nodeName === "A";
};
/**
 * Type-guard that narrows Element to HTMLAnchorElement
 */ var nodeIsImg = function(node) {
    return node.nodeType === 1 && node.nodeName === "IMG";
};
var nodeIsIframe = function(node) {
    return node.nodeType === 1 && node.nodeName === "IFRAME";
};
/**
 * Processes a single HTML Element, possibly modifying it.
 * Some of the behavior is dictated by SanitizeConfig.
 */ var processElement = function(currentNode, sanitizeConfig) {
    if (nodeIsAnchor(currentNode)) {
        processAnchorRel(currentNode);
    } else if (nodeIsImg(currentNode) && !sanitizeConfig.allowExternalImages) {
        processImgSrc(currentNode);
    } else if (nodeIsIframe(currentNode)) {
        processIframe(currentNode, sanitizeConfig);
    }
    return currentNode;
};
export function setInnerHtmlSanitized(element, html, options, customProcessor) {
    // Merge options with the default config.
    var config = _objectSpread({}, DEFAULT_SANITIZE_CONFIG, options || {});
    var allowUnsanitized = config.allowUnsanitized, allowAnchorTarget = config.allowAnchorTarget, allowIframe = config.allowIframe, // eslint-disable-next-line @typescript-eslint/naming-convention
    unsafe_allowStyle = config.unsafe_allowStyle;
    if (!allowUnsanitized) {
        var processor = function(elem) {
            return processElement(elem, config);
        };
        /**
     * Adds a hook to the DOMPurify config for pre-processing elements.
     * This allows for manipulating elements via the DOM api before the
     * sanitization step.
     * https://github.com/cure53/DOMPurify#hooks
     */ DOMPurify.addHook("beforeSanitizeElements", processor);
        if (customProcessor) {
            DOMPurify.addHook("afterSanitizeElements", customProcessor);
        }
        var addAttrs = [];
        if (allowAnchorTarget) {
            addAttrs.push("target");
        }
        if (allowIframe) {
            addAttrs.push("allow", "allowfullscreen", "frameborder", "height", "referrerpolicy", "src", "title", "width");
        }
        if (unsafe_allowStyle) {
            addAttrs.push("scoped");
        }
        html = DOMPurify.sanitize(html, {
            FORBID_TAGS: unsafe_allowStyle ? _toConsumableArray(FORBIDDEN_TAGS.filter(function(tag) {
                return tag !== "style";
            })) : _toConsumableArray(FORBIDDEN_TAGS),
            ADD_ATTR: addAttrs.length > 0 ? addAttrs : undefined,
            ADD_TAGS: allowIframe ? [
                "iframe"
            ] : undefined
        });
        // Remove the hooks when processing is finished.
        DOMPurify.removeHook("beforeSanitizeElements");
        if (customProcessor) {
            DOMPurify.removeHook("afterSanitizeElements");
        }
    }
    if ("innerHTML" in element) {
        element.innerHTML = html;
        return element;
    } else {
        return /*#__PURE__*/ React.cloneElement(element, {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
/**
 * Sanitize unsafe strings for use in HTML nodes, using setInnerHtmlSanitized
 * under the hood. This is an uncommon exception, and should only be used when
 * the target element is not available when content is being sanitized.
 *
 * In all cases where it is otherwise natural, use setInnerHtmlSanitized.
 */ export function sanitizeUnsafeString(unsafeString, options) {
    var tempElement = document.createElement("div");
    setInnerHtmlSanitized(tempElement, unsafeString, options);
    return tempElement.textContent;
}
// Set all external image links to open in a new tab.
export var processExternalImgLinks = function(container) {
    Array.from(container.getElementsByClassName(EXTERNAL_MEDIA_CLASS_NAME)).forEach(function(link) {
        link.setAttribute("target", "_blank");
    });
};
export function isScreenUnderWidth(widthInPx) {
    // Added fallback to handle errors that occur in unit test context.
    try {
        return window.matchMedia("(max-width: ".concat(widthInPx, "px)")).matches;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("Error occurred calling window.matchMedia.", _instanceof(err, Error) && err.message);
        return false;
    }
}
export function useMobileWidth(widthInPx) {
    var ref = _slicedToArray(React.useState(isScreenUnderWidth(widthInPx)), 2), isMobileWidth = ref[0], setIsMobileWidth = ref[1];
    React.useEffect(function() {
        var listener = throttle(function() {
            return setIsMobileWidth(isScreenUnderWidth(widthInPx));
        }, 500);
        window.addEventListener("resize", listener);
        return function() {
            return window.removeEventListener("resize", listener);
        };
    });
    return isMobileWidth;
}
/**
 * Returns the BoundingClientRect object of the viewport (what
 * window.getBoundingClientRect() would return if that API existed)
 */ export function getViewportRect() {
    var html = document.documentElement;
    return makeDomRect({
        top: 0,
        bottom: html.clientHeight,
        left: 0,
        right: html.clientWidth
    });
}
/**
 * Returns the intersection rectangle of two DOMRect objects, typically
 * generated with element.getBoundingClientRect()
 */ export function getIntersectionRect(rect1, rect2) {
    return makeDomRect({
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom),
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right)
    });
}
/**
 * Whether the first rectangle is contained entirely within the second
 * rectangle. DOMRect instances are generated using
 * element.getBoundingClientRect()
 */ export function containsRect(rect1, rect2) {
    return rect1.top >= rect2.top && rect1.left >= rect2.left && rect1.right <= rect2.right && rect1.bottom <= rect2.bottom;
}
// The next three functions are all from
// https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/
/**
 * Tests whether the element's bounds are at least partially visible within
 * the current viewport
 */ export function isElementPartiallyInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
    var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
    return vertInView && horInView;
}
/**
 * Tests whether the element's bounds are entirely visible within the
 * current viewport
 */ export function isElementCompletelyInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
    return rect.left >= 0 && rect.top >= 0 && rect.left + rect.width <= windowWidth && rect.top + rect.height <= windowHeight;
}
/**
 * Tests whether the element is at least partially inside the viewport and
 * whether any part of it is visible to the user (not overlapped, etc)
 */ export function isElementVisible(el) {
    var rect = el.getBoundingClientRect();
    var vWidth = window.innerWidth || document.documentElement.clientWidth;
    var vHeight = window.innerHeight || document.documentElement.clientHeight;
    var efp = function(x, y) {
        return document.elementFromPoint(x, y);
    };
    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) {
        return false;
    }
    // Return true if any of its four corners are visible
    return el.contains(efp(rect.left, rect.top)) || el.contains(efp(rect.right, rect.top)) || el.contains(efp(rect.right, rect.bottom)) || el.contains(efp(rect.left, rect.bottom));
}
/**
 * Makes a DOMRect object from top/bottom/left/right points.
 */ export function makeDomRect(param) {
    var top = param.top, bottom = param.bottom, left = param.left, right = param.right;
    var rect = {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        x: left,
        y: top,
        height: bottom - top,
        width: right - left
    };
    return _objectSpreadProps(_objectSpread({}, rect), {
        toJSON: function() {
            return rect;
        }
    });
}
export var getSiteScrollContainer = function() {
    return document.getElementById("site-content");
};
export function scrollToOffset(topOffset) {
    var container = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSiteScrollContainer(), options = arguments.length > 2 ? arguments[2] : void 0;
    if (!container) {
        return;
    }
    if (options === null || options === void 0 ? void 0 : options.smooth) {
        try {
            var ref;
            container.scroll({
                top: topOffset - ((ref = options === null || options === void 0 ? void 0 : options.topOffset) !== null && ref !== void 0 ? ref : 0),
                left: container.scrollLeft,
                behavior: "smooth"
            });
            return;
        } finally{}
    }
    container.scrollTop = topOffset;
}
export function scrollToElement(target) {
    var container = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSiteScrollContainer(), options = arguments.length > 2 ? arguments[2] : void 0;
    if (!container || !target) {
        return;
    }
    var ref;
    var topOffset = (ref = options === null || options === void 0 ? void 0 : options.topOffset) !== null && ref !== void 0 ? ref : container === getSiteScrollContainer() ? TOP_NAV_HEIGHT : 0;
    var scrollTop = target.getBoundingClientRect().top + container.scrollTop - topOffset;
    if (options === null || options === void 0 ? void 0 : options.smooth) {
        try {
            container.scroll({
                top: scrollTop,
                left: container.scrollLeft,
                behavior: "smooth"
            });
            return;
        } finally{}
    }
    container.scrollTop = scrollTop;
}
var DEFAULT_WAIT_FOR_ELEMENT_OPTIONS = {
    intervalMs: 50,
    shouldWait: function() {
        return false;
    },
    scrollMethod: "scrollToElement",
    timeoutMs: 5000
};
/**
 * This helper uses polling (via `setInterval`) to wait for the target element to
 * be present before scrolling. When the element is present, scroll to the element
 * according to the provided options. If the conditions aren't met within the
 * specified `timeoutMs`, polling is terminated internally.
 *
 * This method returns a callback that can be used to clear the interval, in case
 * that's desired before the helper clears it internally (e.g. in a `useEffect`
 * during a component's unmount).
 */ export var waitForElementAndScroll = function(targetRef) {
    var container = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSiteScrollContainer(), waitForElementOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DEFAULT_WAIT_FOR_ELEMENT_OPTIONS, scrollOptions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _intervalMs = waitForElementOptions.intervalMs, intervalMs = _intervalMs === void 0 ? DEFAULT_WAIT_FOR_ELEMENT_OPTIONS.intervalMs : _intervalMs, scrollMethod = waitForElementOptions.scrollMethod, _shouldWait = waitForElementOptions.shouldWait, shouldWait = _shouldWait === void 0 ? DEFAULT_WAIT_FOR_ELEMENT_OPTIONS.shouldWait : _shouldWait, _timeoutMs = waitForElementOptions.timeoutMs, timeoutMs = _timeoutMs === void 0 ? DEFAULT_WAIT_FOR_ELEMENT_OPTIONS.timeoutMs : _timeoutMs, withTopOffset = waitForElementOptions.withTopOffset;
    var totalTimeMs = 0;
    var intervalId = setInterval(function() {
        // If the timeout has expired, stop polling
        if (totalTimeMs >= timeoutMs) {
            clearInterval(intervalId);
            return;
        }
        /**
     * Only scroll to the element if:
     * - The target is present
     * - The optional callback determines that we no longer need to wait (if applicable)
     */ if (targetRef.current && !shouldWait()) {
            var topOffset = withTopOffset ? withTopOffset() : scrollOptions.topOffset;
            switch(scrollMethod){
                case "scrollToElement":
                    scrollToElement(targetRef.current, container, _objectSpreadProps(_objectSpread({}, scrollOptions), {
                        topOffset: topOffset
                    }));
                    break;
                case "scrollToOffset":
                    scrollToOffset(topOffset !== null && topOffset !== void 0 ? topOffset : 0, container, scrollOptions);
                    break;
            }
            // We've scrolled, so we can stop polling
            clearInterval(intervalId);
        }
        totalTimeMs += intervalMs;
    }, intervalMs);
    return function() {
        return clearInterval(intervalId);
    };
};
export var checkVisibilityAndScroll = function(ref, topOffset) {
    if (ref.current !== null) {
        if (!isElementCompletelyInViewport(ref.current)) {
            scrollToElement(ref.current, getSiteScrollContainer(), {
                topOffset: topOffset
            });
        }
    }
};
export function scrollToId(id) {
    var container = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSiteScrollContainer(), options = arguments.length > 2 ? arguments[2] : void 0;
    scrollToElement(document.getElementById(String(id)), container, options);
}
export function scrollToHash() {
    var container = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getSiteScrollContainer(), options = arguments.length > 1 ? arguments[1] : void 0;
    scrollToId(window.location.hash.slice(1), container, options);
}
/**
 * Copies text to clipboard using the legacy / deprecated execCommand API.
 * http://go/mdn/API/Document/execCommand
 */ export var copyToClipboardLegacy = function(text) {
    var copyFunction = function(e) {
        e.clipboardData.setData("text/plain", text);
        e.preventDefault();
        document.removeEventListener("copy", copyFunction);
    };
    document.addEventListener("copy", copyFunction);
    document.execCommand("copy");
};
/**
 * Copies text to clipboard preferring the newer Clipboard API first, see
 * http://go/mdn/API/Clipboard_API
 */ export function copyToClipboard(text) {
    // The Clipboard API requires browsers to support it, as well as a secure
    // (https) connection or local dev. window.isSecureContext will be set to
    // true by browsers for 'localhost' hostname.
    if (!navigator.clipboard || !window.isSecureContext) {
        copyToClipboardLegacy(text);
        return;
    }
    navigator.clipboard.writeText(text).catch(function() {
        // Fallback on the legacy approach if there's an issue. The Clipboard API
        // could be denied through a user's browser settings, or if the tab or
        // document is not in focus.
        copyToClipboardLegacy(text);
    });
}
export function pathnameToPathArray(pathname) {
    return pathname.split("/").filter(function(p) {
        return !!p;
    }).map(function(e) {
        return e.toLowerCase();
    });
}
export function ansiRegex() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _onlyFirst = ref.onlyFirst, onlyFirst = _onlyFirst === void 0 ? false : _onlyFirst;
    var pattern = [
        "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
        "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-nq-uy=><~]))", 
    ].join("|");
    return new RegExp(pattern, onlyFirst ? undefined : "g");
}
export function stripAnsi(string) {
    if (typeof string !== "string") {
        throw new TypeError("Expected a `string`, got `".concat(typeof string === "undefined" ? "undefined" : _typeof(string), "`"));
    }
    return string.replace(ansiRegex(), "");
}
export var ANSI_ESCAPE_REGEX = /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]/g;
export var stripAnsiEscapeCodes = function(str) {
    return str.replace(ANSI_ESCAPE_REGEX, "");
};
export function getFocusableChildren(element) {
    var ref;
    var allFocusables = _toConsumableArray((ref = element.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')) !== null && ref !== void 0 ? ref : []).filter(function(el) {
        return !el.hasAttribute("disabled");
    });
    return allFocusables;
}
/**
 * Checks if an element is visible within its overflow container visible area.
 * @param element An element to check if it visible in an overflow container.
 *     This should be a descendent of 'container'.
 * @param container A div that has CSS overflow set to hidden or scroll.
 */ export function isWithinOverflowContainer(element, container) {
    var containerRect = container.getBoundingClientRect();
    var elementRect = element.getBoundingClientRect();
    return elementRect.top >= containerRect.top && elementRect.bottom <= containerRect.bottom && elementRect.left >= containerRect.left && elementRect.right <= containerRect.right;
}
/** Forces an image to be loaded into the browser cache. */ export function preloadImage(src) {
    // A little hacky, but it works. See https://stackoverflow.com/q/42615556
    new Image().src = src;
}
